import { DashboardModule, Form } from '@domain-group/suit-theme'

import PortalDataInput from '../PortalDataInput'

const LandDetails = () => (
  <DashboardModule boxProps={{ flexDirection: 'column', marginBottom: 'large' }} title="Land Details">
    <Form padding="large">
      <Form.Row>
        <Form.Row>
          <PortalDataInput fieldKey="lotNumber" />

          <PortalDataInput marginTop={['large', 0]} fieldKey="area" />
        </Form.Row>

        <PortalDataInput marginTop={['large', 0]} fieldKey="areaUnit" />
      </Form.Row>

      <Form.Row>
        <PortalDataInput marginTop="large" fieldKey="frontage" />

        <PortalDataInput marginTop="large" fieldKey="councilRates" />
      </Form.Row>
    </Form>
  </DashboardModule>
)

export default LandDetails
